export const PRIVACY_POLICY_URL = "https://www.thoughtfull.world/privacy-policy";
export const TERMS_OF_USE_URL = "https://www.thoughtfull.world/clients-terms-of-use";
export const OMWA_URL = "https://www.thoughtfull.world/employers/organisational-mental-wellness-assessment";
export const TFI_NEW_URL = process.env.REACT_APP_TFI_NEW_URL;
